import bicycle from "../assets/icons/bicycle.svg";
import car from "../assets/icons/car.svg";
import English from "../assets/icons/english.svg";
import exitToApp from "../assets/icons/exit-to-app.svg";
import foot from "../assets/icons/foot.svg";
import handOutline from "../assets/icons/hand-outline.svg";
import keyboardOutline from "../assets/icons/keyboard-outline.svg";
import Portugues from "../assets/icons/portugues.svg";
import scanOutline from "../assets/icons/scan-outline.svg";
import Spanish from "../assets/icons/spanish.svg";
import { CompanionOption, CompanionType } from "../passapp-sdk/models/CompanionOption";
import { EntryMethod, EntryType } from "../passapp-sdk/models/EntryMethod";
import BundleKey from "../translation/bundleKey";
import { EntrantTabIndex } from "./tabIndex";

export const languageOptions = [
  {
    id: "es_ES",
    bundleName: BundleKey.LANG_SPANISH,
    iconUrl: Spanish,
  },
  {
    id: "en_US",
    bundleName: BundleKey.LANG_ENGLISH,
    iconUrl: English,
  },
  {
    id: "pt_BR",
    bundleName: BundleKey.LANG_PORTUGUESE,
    iconUrl: Portugues,
  },
];
export const entryMethods: EntryMethod[] = [
  {
    bundleName: BundleKey.DETAIL_ENTRYMETHOD_FOOT,
    type: "none",
    iconUrl: foot,
    id: EntryType.FOOT,
  },
  {
    bundleName: BundleKey.DETAIL_ENTRYMETHOD_CAR,
    type: "car",
    iconUrl: car,
    id: EntryType.CAR,
  },
  {
    bundleName: BundleKey.DETAIL_ENTRYMETHOD_BICYCLE,
    type: "bike",
    iconUrl: bicycle,
    id: EntryType.BICYCLE,
  },
];
export const companionOptions: CompanionOption[] = [
  {
    type: "manual_entry",
    bundleTitle: BundleKey.MENU_MANUALINPUT,
    iconUrl: keyboardOutline,
    id: CompanionType.MANUAL_ENTRY,
    tabIndex: EntrantTabIndex.companionManualEntry,
  },
  {
    type: "scan",
    bundleTitle: BundleKey.MENU_SCAN,
    iconUrl: scanOutline,
    id: CompanionType.SCAN,
    tabIndex: EntrantTabIndex.companionScan,
  },
];

export enum RoutePaths {
  Login = "/",
  Dashboard = "/dashboard",
  LogisticPark = "/lp",
  LogisticParkHome = "/lp/home",
  LogisticParkExitUsers = "/lp/exit-users",
  LogisticParkEntryRegistration = "/lp/entry-registration",
  LogisticParkRegistroIngreso = "/lp/entry-registration",
  LogisticParkScanDNI = "/lp/scan-dni",
  Incomes = "/incomes",
  Reservations = "/reservations",
  ReservationScan = "/reservations/scan",
  ReservationResult = "/reservation",
  SearchManualInput = "/dashboard/search",
  RegisterExit = "/dashboard/registerExit",
  MultipleExit = "/dashboard/multipleExit",
  Scan = "/dashboard/scan",
  PendingRequest = "/dashboard/pendingRequest",
  EntryEvent = "/dashboard/entryEvent",
}

export const items = [
  {
    src: keyboardOutline,
    bundleTitle: BundleKey.MENU_MANUALINPUT,
    href: RoutePaths.Dashboard,
    keys: "ALT+1",
    modal: true,
  },
  {
    src: scanOutline,
    bundleTitle: BundleKey.MENU_SCAN,
    href: RoutePaths.Scan,
    keys: "ALT+2",
  },
  {
    src: handOutline,
    bundleTitle: BundleKey.MENU_AWAITINGREQUEST,
    href: RoutePaths.PendingRequest,
    showBadge: true,
    keys: "ALT+3",
  },
  {
    src: exitToApp,
    bundleTitle: BundleKey.MENU_REGISTEREXIT,
    href: RoutePaths.RegisterExit,
    keys: "ALT+4",
  },
];
